import {
  FETCH_LIST_ALL_DOCUMENTS_FOR_PROJECT_ASSOCIATION_REQUEST,
  FETCH_LIST_ALL_DOCUMENTS_FOR_PROJECT_ASSOCIATION_SUCCESS,
  FETCH_LIST_ALL_DOCUMENTS_FOR_PROJECT_ASSOCIATION_FALUIRE,
} from './listAllDocumentForProjectAssociationTypes'

const initialState = {
  loading: false,
  allDocumentsForProjectAssociation: null,
  error: '',
}

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_LIST_ALL_DOCUMENTS_FOR_PROJECT_ASSOCIATION_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_LIST_ALL_DOCUMENTS_FOR_PROJECT_ASSOCIATION_SUCCESS : return {
      ...state,
      allDocumentsForProjectAssociation: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_LIST_ALL_DOCUMENTS_FOR_PROJECT_ASSOCIATION_FALUIRE : return {
      ...state,
      loading: false,
      allDocumentsForProjectAssociation: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
